export default __webpack_public_path__ + "static/media/snlc-college.42e01318.webp";